import { Player } from '@/types';

export type ScoutingAgg = {
  shooting: number;
  passing: number;
  pace: number;
  dribbling: number;
  defending: number;
  physical: number;
};

export const draftStorageKey = (workspaceId: string) => `htfc.team.selection.v2:${workspaceId}`;

export type TeamSelectionDraft = {
  workspaceId: string;
  formationName: string;
  selected: PositionMap;
  benchIds: string[];
  unresolvedPositionIds?: Record<string, string>;
  saveName?: string;
  matchDate?: string;
  baseline?: string;
};

export type TeamSelectionPlayerPayload = {
  id: string;
  name: string;
  age: number;
  position: Player['position'];
  team: string | null;
  photo_url: string | null;
  availability: string;
  latest_performance_rating: number;
  scouting: ScoutingAgg;
};

export type TeamSelectionPlayer = Pick<Player, 'id' | 'name' | 'age' | 'position' | 'team' | 'photoUrl'> & {
  injuryStatus: string;
  latestPerformanceRating: number;
  scouting: ScoutingAgg;
};

export type PositionMap = Record<string, TeamSelectionPlayer | undefined>;

export type SavedLineupV2 = {
  id: string;
  name: string;
  formation: string;
  positions: Record<string, string>;
  bench_ids: string[];
  match_date: string | null;
  saved_performance: Record<string, number>;
  created_at: string;
};
